const SvgSearchGlyph = props => (
  <svg width={16} height={16} viewBox='0 0 16 16' {...props}>
    <path d='M11.89 10.477l2.817 2.816a1 1 0 01-1.414 1.414l-2.816-2.816a6 6 0 111.414-1.414zM7 11a4 4 0 100-8 4 4 0 000 8z' />
  </svg>
);

export default SvgSearchGlyph;
